import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled, { keyframes } from 'styled-components';

import { rem, colors, device } from '../lib/global-styles';
import FlashMessage from './FlashMessage';
import { currencyFilter, validateCardForm } from '../lib/utils';
import CardForm from './CardForm';
import { Button } from './Button';
import carIcon from '../images/ic_car-white.svg';
import closeIcon from '../images/ic_close.svg';
import { getFlashMessage } from '../store/selectors';
import { doRequestSubscription, doSetFlashMessage } from '../store/actions';

const fadeIn = keyframes`
  from {
    right: -${rem(520)};
    opacity: 0;
  }

  to {
    right: 0;
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    right: 0;
    opacity: 1;
  }

  to {
    right: -${rem(520)};
    opacity: 0;
  }
`;

export const CheckoutBody = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  min-height: 100vh;
  z-index: 1000;
`;

const CheckoutWrapper = styled.div`
  background: #fafaff;
  max-width: ${rem(520)};
  animation: ${props => (props.open ? fadeIn : fadeOut)} 0.7s linear;
  transition: visibility 0.5s linear;
  position: absolute;
  right: 0;
  height: 100%;

  h3 {
    margin-top: ${rem(16)};
    margin-bottom: ${rem(8)};
    color: ${colors.darkGrey};
    font-size: ${rem(16)};
    font-weight: normal;

    @media ${device.mobile} {
      padding-left: ${rem(24)};
    }
  }

  @media ${device.mobile} {
    width: ${rem(335)};
  }
`;

const SidebarContent = styled.div`
  margin: auto;
  width: ${rem(320)};
  padding: ${rem(25)} ${rem(100)};

  @media ${device.mobile} {
    padding: ${rem(25)} ${rem(10)};
  }
`;

const CheckoutTitle = styled(SidebarContent)`
  background: ${colors.titleBackground};
  color: ${colors.darkGrey};
  font-size: ${rem(20)};
  font-weight: bold;
  letter-spacing: ${rem(0.25)};
  line-height: ${rem(24)};

  @media ${device.mobile} {
    padding: ${rem(25)} ${rem(24)};
  }
`;

const CloseButton = styled.button`
  background: #d0d1d8 url(${closeIcon}) no-repeat center;
  border: none;
  border-radius: ${rem(20)};
  font-size: 0;
  line-height: ${rem(36)};
  height: ${rem(24)};
  width: ${rem(24)};
  margin-right: ${rem(16)};
`;

const SelectedProduct = styled.div`
  display: flex;
  padding: ${rem(16)};
  padding-right: ${rem(55)};
  background-color: ${colors.white};
  box-shadow: 0 ${rem(5)} ${rem(16)} 0 rgba(0, 0, 0, 0.1);
  font-weight: bold;
  font-size: ${rem(18)};
  align-items: flex-end;
  border-radius: ${rem(5)};

  h4 {
    color: ${props => colors[props.color]};
    font-size: ${rem(16)};
  }

  span {
    margin-left: auto;
    margin-right: ${rem(5)};
    font-size: ${rem(14)};
  }

  @media ${device.mobile} {
    margin: ${rem(8)} ${rem(20)} ${rem(8)} ${rem(24)};
  }
`;

class Checkout extends Component {
  state = {
    card: {
      cvv: '',
      number: '',
      validity: '',
    },
    error: {
      number: '',
      validity: '',
      cvv: '',
    },
  };

  onChangeInput = e => {
    const { name, value } = e.target;
    const { card } = this.state;
    const updatedCard = { ...card, [name]: value };

    this.setState({ card: updatedCard });
  };

  renderSidebarContent = () => {
    const { flashMessage, selectedProduct, selectedColor, edit } = this.props;
    const { card, error } = this.state;

    if (flashMessage.type) {
      return <FlashMessage onCloseClick={this.onCloseCheckout} />;
    } else {
      return (
        <>
          <h3>O que você escolheu:</h3>
          <SelectedProduct color={selectedColor}>
            <h4>{selectedProduct.groupName} Recorrente</h4>
            {currencyFilter(selectedProduct.price)}/mês
          </SelectedProduct>
          {!edit ? (
            <CardForm onChangeInput={this.onChangeInput} card={card} error={error} filled>
              <Button onClick={this.onClickSubmit} type="submit" dark noBorder image={carIcon}>
                Pagar
                <span />
              </Button>
            </CardForm>
          ) : (
            <Button onClick={this.onClickSubmit} type="submit" dark noBorder image={carIcon}>
              Trocar plano
              <span />
            </Button>
          )}
        </>
      );
    }
  };

  onClickSubmit = e => {
    e.preventDefault();

    const { selectedProduct, onRequestSubscription } = this.props;
    const { card } = this.state;
    const { validated, error } = validateCardForm(card);

    if (validated) {
      onRequestSubscription({
        card,
        product: { codigo: selectedProduct.id, price_list: selectedProduct.priceListId },
      });
    } else {
      this.setState({ error });
    }
  };

  render() {
    const { checkoutOpen, selectedProduct, onCloseCheckout } = this.props;

    return selectedProduct ? (
      <CheckoutBody onClick={e => onCloseCheckout(e)}>
        <CheckoutWrapper open={checkoutOpen}>
          <CheckoutTitle>
            <div>
              <CloseButton onClick={e => onCloseCheckout(e, true)}>X</CloseButton> Pagamento
            </div>
          </CheckoutTitle>
          <SidebarContent>{this.renderSidebarContent()}</SidebarContent>
        </CheckoutWrapper>
      </CheckoutBody>
    ) : null;
  }
}

Checkout.propTypes = {
  flashMessage: PropTypes.object,
  onRequestSubscription: PropTypes.func,
  onSetFlashMessage: PropTypes.func,
};

const mapStateToProps = state => ({
  flashMessage: getFlashMessage(state),
});

const mapDispatchToProps = dispatch => ({
  onRequestSubscription: payload => dispatch(doRequestSubscription(payload)),
  onSetFlashMessage: payload => dispatch(doSetFlashMessage(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Checkout);
